 export enum OrgansSystems {
  BLD = "FE.80efc23b-268d-473b-9411-cbf68a5112f3",
  FLD_ELCT = "FE.f38deab9-8738-45da-a548-92b4065627ee",
  CVD = "FE.977b3587-7dd0-47dc-8b04-e7ae84e38542",
  ENDO = "FE.e46d7e23-27a2-4b2a-941e-e000fac3ddac",
  GI = "FE.688c7eda-ef3b-432c-a03b-b1bdff532fc0",
  GU = "FE.d20343a9-07c1-427e-b167-de281bc7e761",
  HEM = "FE.7746bd91-e0da-462b-ba41-4a75895dd022",
  IMM = "FE.41dbc037-3261-4fe2-85cd-53aa72bf0e80",
  INF = "FE.235977d5-3d1b-4598-8b66-6a4557bef736",
  LYM = "FE.8d8a070a-194a-4b06-9862-e5ebfe7aa95b",
  MSK = "FE.8c781c6a-1c86-4103-8bd0-94ec1878da3e",
  NEU = "FE.401a4288-6f46-4046-a898-053176924a0f",
  ONCNEU = "FE.5370c2ad-b850-4ce4-90b3-4e7b4753a187",
  ONC = "FE.a4c558f6-257a-4ff2-817e-fd6bc36c508a",
  OTH = "FE.ea30fec3-4803-4483-9fd5-335e8004be8b",
  RESP = "FE.5422e33f-e44a-4381-9941-37756534d5a6",
  SKIN = "FE.540939e4-25d7-4b01-ad24-a2ebf160e74f",
  META = "FE.6547b850-f6f1-4e7f-ba4e-d02c3ea4bf5a",
  VS = "FE.e751543a-4b95-4a51-817c-318b47f593bc",
  AD = "FE.12efdf58-6583-43eb-a6fd-0a412dfc331a",
  PSY = "FE.03261b37-efbe-4018-af6f-67fe0fbe6004",
}

export enum Relations {
  AGE_OF_ONSET = "RE.70a4ffb9-785c-4048-9fbc-07ad224b5427",
  AGE_OF_PRESENTATION = "RE.046fab26-8d48-4b92-a055-109837f41df2",
  ALLERGY_REACTIONS = "RE.f2908456-a668-48bc-83fa-67aeee165e73",
  APPEARANCE = "RE.c554a32e-6901-456e-b15d-e3b3e7f64902",
  APPEARANCES = "RE.bbfa0908-d9b1-4965-8ad9-10cbb48df0c2",
  ASSOCIATED_MORPHOLOGY = "RE.bbfa0908-d9b1-4965-8ad9-10cbb48df0c2",
  ATTRIBUTE = "RE.2e8cbcbd-48c3-418a-ba25-33ce60fa4828",
  CARE_SETTING = "RE.4dfe2eec-3015-4531-b919-5a50e7bcd7d8",
  CATEGORY = "RE.6a0c6fa8-2e56-448d-bd46-56a23a918f82",
  CHARACTER = "RE.ff72aa56-f184-43fc-a53c-5cd3bc1606d3",
  CHARACTER_PITCH = "RE.bfc5ea36-b50c-424e-b262-9f1cbb580f26",
  CLINICAL_COURSE = "RE.1de3b34f-04de-4ef8-965a-0803863c252e",
  CTAS_SCORE = "RE.47d206e0-3efd-451d-9b9e-a9ed18812513",
  DISEASE_INCIDENCE = "RE.4e848943-a608-46bf-8fc3-9d7bea869cfd",
  DISEASE_LENGTH = "RE.61a70260-1d26-4af1-87fa-986bd0dfdb47",
  DISEASE_URGENCY = "RE.774fb441-2362-4d9e-8856-5c57977d65b2",
  DOSAGE = "RE.8257f6d5-e358-4a22-9462-da27ef59ca23",
  DRINKING_FREQUENCY = "RE.5a5a093c-693e-4575-9633-9926f5104e70",
  DUE_TO = "RE.55a12483-0066-4829-93bb-a90b6861f6c2",
  DURATION = "RE.aed5eb1d-9d25-40dd-8f9e-cdb6e3501adb",
  ETHNIC_GROUP = "RE.5e72f218-287c-4cf3-adcf-fd72922db963",
  EXPOSURE_TO = "RE.c0bcc99a-d90a-471b-854b-653da51b1224",
  FAMILY_HISTORY = "RE.bfbce7cc-1fc0-455b-ac71-06fad733cd55",
  FLARE_OF = "RE.98137179-07c6-4ca0-a487-1918fcd442bc",
  FREE_TEXT = "RE.e55145da-9ec5-4c2f-a53a-7608bb21b468",
  FREQUENCY = "RE.e6953f49-ef8e-49b0-83a2-6c6791b50a52",
  GENDER = "RE.046fab26-8d48-4b92-a055-109837f41df2",
  GEOGRAPHIC = "RE.5682b249-109c-443f-b794-09930a924da4",
  HISTORY_OF = "RE.e86c3b4f-5de0-4ff8-9c01-83edf55aca61",
  INTENSITY = "RE.c3e584c9-eedf-4542-94f5-43b7a8cfc1a8",
  LATERALITY = "RE.c64eb26f-35ee-47f1-bde4-b54a7f899f5c",
  LEAK = "RE.5fd788d3-e54a-4fce-841c-fdb7ceb74140",
  LEVEL = "RE.7ec4ee4f-4028-4fc5-abe4-ad66ba5b5163",
  LOCATION = "RE.0beab460-4811-4914-83ae-cae120777889",
  OCCUPATION = "RE.c4dd2f81-82b1-48a2-9aa2-6664f8f71b53",
  OCCURANCE = "RE.d2d89af5-2c8b-490a-8e05-34a03510d993",
  ORGAN_SYSTEM = "RE.acc2fa53-2783-4f80-bb6a-f9a800f3546a",
  ONSET = "RE.7f770c55-3348-4444-9813-171c91643b86",
  PANEL_ID = "RE.845b7240-bc84-4ade-82f3-d25d3f8d0a6c",
  PATIENT_FACING_LIMIT = "RE.afd26adf-9da0-4108-bcd5-0a767c18119a",
  PERIODS_OF_LIFE = "RE.39049194-f191-40b1-8820-4437d725637e",
  PITCH = "RE.f54c70ac-ee36-48eb-94fb-e618b8317372",
  PROCEDURE = "RE.00000000-0000-0000-0000-000000000005",
  PROCEDURE_FINDING = "RE.c40e7df0-d302-4c98-8aa7-e18ef2a57f87",
  PULSE_FINDING = "RE.fc7349bb-24c4-4e20-a0c1-5bc294449be0",
  QUALITY = "RE.b6f2d702-c72c-40ad-92d2-a70e179fd2bc",
  RADIATING = "RE.0960131f-2904-4296-9389-86610a6c5a60",
  RELATIVE_SITE = "RE.5216d669-53f4-4893-9326-5dd9c294b4d4",
  RELIEVED_BY = "RE.f1433187-6494-4704-8a29-17fa766df754",
  SEVERITY = "RE.574b07a4-9793-4fd8-a3c8-ec1e9753fa4b",
  SHAPE = "RE.b3ca7d7d-e0a5-4c3d-a217-e3084a431ef7",
  SIDENESS = "RE.521a62f6-8537-4fc0-aed1-daf631daa952",
  SMOKING_DURATION = "RE.a38feb50-482a-4986-8092-f44bb7b3f35c",
  SMOKING_FREQUENCY = "RE.b7a0556b-820e-4a0c-a89c-5a4f25436d7f",
  TIMING = "RE.ba5ec34a-2a3b-47a0-9961-8c2d05f7d722",
  TRAVEL_HISTORY = "RE.2cbc4122-c532-46c8-ac05-66478e5468cc",
  TRIGGERED_BY = "RE.190dccbb-7fa5-4262-865f-e4d8e4f1cc1c",
  WORSENED_BY = "RE.2171c7e5-394d-4853-9470-7cd437ea4e8a",
  PATIENT_FACING_FOR_SETTING = "RE.8c0ca94d-ff2f-4ab7-9c76-58d64bbcb0ce",
}

export enum KahunProcedures {
  CHEST_XRAY = "FE.29c31fcb-49f3-40a8-aa7f-adac528e0367",
  ECG = "FE.a340c25b-cc3e-46f5-920d-17a3c93ca410",
  CT_OF_CHEST = "FE.b8788859-9f6f-4508-b057-97a424d6c7be",
}

export enum Values {
  HIGH = "FE.1546f32c-14d2-4281-8b01-c8bb68bb7b44",
  LOW = "FE.4dcf874b-0e7c-4b83-824d-b2b85487b723",
  NORMAL = "FE.74aa59af-e13c-4a5b-8b74-5f196c7cea64",
  CHRONIC = "FE.5a1ed7f1-7490-4d4f-8ecd-7231f105c891",
  ACUTE = "FE.f6e8de0d-fabe-4d35-a74c-46b7c4d03c19",
}

export enum GenderValue {
  MALE = "FE.2f94aa86-ac10-4b82-ab9b-b9ae3d0dfb96",
  FEMALE = "FE.4aa7c292-3270-43a2-a012-753888709f4e",
}

export enum KahunCategories {
  VITAL_SIGNS = "FE.a37f09b7-214d-4f76-acfd-1b28807f4701",
  LAB_TEST = "FE.0e9afb45-5a97-4338-9267-50ab1579104a",
  HISTORY = "FE.4dff3d0d-96fe-4db2-9636-4f276c2dfa19",
  SIGNS_SYMPTOMS = "FE.7bb51dc9-6c41-464d-bdb7-d9007a653ac3",
  KAHUN_SYMPTOMS = "FE.a44f1d30-7124-4c82-bc8b-6e5ff7266a29",
  IMAGING = "FE.83e6a3ae-b26e-4716-b089-e48c2015019a",
  DEMOGRAPHIC = "FE.1d753f63-1e76-43ba-9272-5f06645914ab",
  DISORDERS = "FE.28f7da94-726c-4cf6-89a7-a107cd0df882",
  COMPLICATIONS = "FE.e748e7a8-c5d5-4406-85c1-782bfa8052ec",
  HABITS = "FE.3898acb9-8cf5-4a89-8004-04a3541af955",
  MEDICINE = "FE.648bfd88-96d3-44be-b952-31786baf56ea",
  TREATMENT = "FE.0d5c6ac7-4a61-454b-a763-71441bef9723",
  ALLERGIES = "FE.bec4667c-b824-407e-b0c6-10c3a7d1aca0",
  SIGN = "FE.ff607b41-fbac-4313-808d-69b8acee27ca",
  PROCEDURE = "FE.eef5f74e-597a-4f19-8d1c-c88d4f72d4a5",
  OCCUPATION = "FE.8adf06a9-0790-411a-bf8e-f93b8d0bb056",
  GEOGRAPHICAL_LOCATION = "FE.94938d1f-d51e-41f9-9cfc-5765d798012d",
  ETHNIC_GROUP = "FE.57b96f23-c198-42c5-8b00-a71c933554de",
  KAHUN_LAB_DISORDERS = "FE.d9ae6068-931b-43d3-b388-3f6f0407fe80",
  KAHUN_MEDICATIONS = "FE.648bfd88-96d3-44be-b952-31786baf56ea",
  RISK_FACTORS = "FE.6876bd25-cda3-4466-a41f-a461c8066e59",
}

export enum KahunPanelSubGroup {
  Medication = "FE.48890c35-d072-42ea-b022-dc5f3738ad69",
  Procedures = "FE.7530d4de-faa3-4ebb-9842-82928612a87e",
  Labs = "FE.27ff6d1a-00bf-4e23-b2ef-e6222118c4f4",
  Metabolic = "FE.a5e81ce2-18c3-4b6a-8368-3ec1d45ba0f1",
  FamliyHistory = "FE.e7f3a255-c3b6-4aab-b88d-4923f2ea539c",
  Habits = "FE.8b5060a2-8eff-4eb5-9fbe-f307271ddead",
  RecentExposure = "FE.afc92766-9853-434d-955a-a8837fd272f8",
  SignSymptom = "FE.4c9e4791-5c8d-4bc8-8932-782c48eafbbc",
  VitalSign = "FE.ad48fd79-9555-4e9e-aad8-fbab6e3971cb",
  ALLERGIES = "FE.fecbc4c1-4ae6-4598-a961-c8582344af7d",
  MedicalHistory = "FE.c91e3f1d-f994-4be7-85a2-a1ed78d4d7a0",
  ActiveProblems = "FE.15c64bb1-a21e-4da7-a3fd-215a21ea5762",
  Demographics = "FE.02e9db3f-56c4-4b15-a845-eccf07046417",
  Other = "Other",
  MostRelevant = "Most Relevant",
  Symptoms = "FE.28afddfd-6b45-47aa-a35f-8bbc3c3d741e",
  // temp - change to real id when possible
  Signs = "FE.002",
}

export enum Urgency {
  MAJOR = "FE.15e83c48-beec-415a-a5fb-ebb0dae52c32",
  EMERGENCY = "FE.a368cd07-15ee-4c28-af38-b3bfdcaa64e1",
  URGENT = "FE.c1bc72d7-bb80-43bc-bfd7-ab6edc17487f",
  SOMEWHAT_URGENT = "FE.5ef0a12c-3e59-4cd5-9f10-f8a91c1eb1f1",
  NOT_URGENT = "FE.da9680bb-7adc-41d4-9985-e4299340ed9a",
}

export const urgencyIdToLevel = {
  "FE.15e83c48-beec-415a-a5fb-ebb0dae52c32": "MAJOR",
  "FE.a368cd07-15ee-4c28-af38-b3bfdcaa64e1": "EMERGENCY",
  "FE.c1bc72d7-bb80-43bc-bfd7-ab6edc17487f": "URGENT",
  "FE.5ef0a12c-3e59-4cd5-9f10-f8a91c1eb1f1": "SOMEWHAT_URGENT",
  "FE.da9680bb-7adc-41d4-9985-e4299340ed9a": "NOT_URGENT",
};

export const urgencyIdToNumeric = {
  "FE.15e83c48-beec-415a-a5fb-ebb0dae52c32": 1,
  "FE.a368cd07-15ee-4c28-af38-b3bfdcaa64e1": 2,
  "FE.c1bc72d7-bb80-43bc-bfd7-ab6edc17487f": 3,
  "FE.5ef0a12c-3e59-4cd5-9f10-f8a91c1eb1f1": 4,
  "FE.da9680bb-7adc-41d4-9985-e4299340ed9a": 5,
};

export const ORPHANS_CLUSTER_ID = "FE.cb147b35-ab4c-403e-8215-d4f7008a453f";
export enum KahunPanels {
  GeographicLocation = "FE.30b99386-68c0-43b8-ac5f-9575ddd0e822",
  EthnicGroup = "FE.71293e13-9751-468c-94f0-71f5a269134a",
  Ocupation = "FE.1fcf21ca-d784-4dcd-8422-af5722a5bf2a",
  ExposureTo = "FE.1521b030-9fb7-44f2-b635-d53b42a40f62",
  TravelHistory = "FE.08ace14d-ecbd-4756-8f43-8feb7429553e",
  VitalSigns = "FE.17681efc-05e6-4699-9138-ce41e87d933e",
}

export enum KahunPanelGroup {
  CLINICAL_FEATURES = "FE.fc44fe4c-b187-4a55-aada-0568a76b24d9",
  WORKUP = "FE.27ce4749-74f5-4cd2-917e-2d3a4a386db0",
  BACKGROUND = "FE.eaf12745-9181-47a6-937d-28a7b759f29f",
  // find correct feature id
  REVIEW_OF_SYSTEMS = "FE.1862c35d-966f-45ed-84db-93aaf02b6515",
}

export enum Panels {
  InternalMedicine = "FE.d7bc7c49-67d5-4a3c-bffa-0fb9fdeb7daa",
  PatientInternalMedicine = "FE.19e40328-ce3b-469a-9320-4b6967a50558",
  RiskFactors = "FE.94381613-409a-4c3c-93d9-991628742695",
  Medicine = "FE.33e4084c-ac6a-4376-b80d-92dfd9b79192",
}

export enum PatientFacingLimits {
  voluntaryOnly = "FE.8ec437fc-30f6-4008-9646-ed686be5e331",
  suggestionOnly = "FE.51b168ea-c040-48a8-baa2-b4636f8f13e0",
  suggestionOrVoluntary = "FE.2be99066-c995-462a-ba8b-8c1c8422d999",
}

export enum Constraints {
  MinAge = 16,
  MaxAge = 120,
}

export const SUBPOPULATION_PREFIX = "FE.SUBPOP.";
export const POPULATION_FEATUREID = "FE.00000000-0000-0000-0000-000000000001";
export const DRUG_OR_MEDICAMENT = "FE.034e2c7e-1194-4d91-8f69-b13f407f7759";
export const GENDER = "FE.SUBPOP.RE.046fab26-8d48-4b92-a055-109837f41df2";
export const AGE = "FE.SUBPOP.RE.39049194-f191-40b1-8820-4437d725637e";
export const PATIENT_COVID_ID = "FE.4f69491f-404b-4391-972d-d8cc5f5dde22";
export const PREGNANCY_FEATURE_ID = "FE.00e43e7c-edfc-4d56-8f41-793c56ab2eae";
export const PREGNANCY_NOT_DETERMINE_FEATURE_ID =
  "FE.5024f14e-157e-46e3-b1dc-210500db8bf2";
export const POSTPARTUM_FEATURE_ID = "FE.0600d895-a518-41c6-8549-67f54ed0e2db";
export const RECOMMENDATIONS_FEATURE_ID =
  "FE.249eee8e-cd1f-4b84-9569-cfb488a2d73b";
export const CONVERSATION_MESSAGES_ID =
  "FE.9c8bc211-e82a-4727-8e32-0d1c712e38a1";
export const NUMERIC_VALUE_FEATURE_ID =
  "FE.8422bf05-f6ff-4e16-91ee-6644a0304eed";
export const FREE_TEXT_FEATURE_ID = "FE.b18c3e3e-e05b-4c2c-b7d4-e5b3f572d3c7";
export const ALLERGIES_FEATURE_ID = "FE.c3a29d59-c863-41a2-910e-2d68a6b5ada1";
export const INFO_MESSAGE_ROOT = "FE.9c8bc211-e82a-4727-8e32-0d1c712e38a1";
export const RECOMMENDATION_ROOT = "FE.249eee8e-cd1f-4b84-9569-cfb488a2d73b";
export const PROTOCOL_ACTIONS_ID = "FE.db464b25-3653-4484-ab78-79f6add754ae";
export const PROMPT_ID = "FE.8a7fd6e3-bcbb-4891-bf40-10ff6fc4f58b";
export const CLOSED_SETS_ID = "FE.6b840138-6364-43fb-8be8-8917fd01cc85";
export const DATE_OF_BIRTH_FEATURE_ID =
  "FE.8c4820a1-41cc-4eef-8f04-d30456adec57";
export const DURATION_FEATURE_ID = "FE.8422bf05-f6ff-4e16-91ee-6644a0304eed";
export const CHECK_MY_SYMPTOMS_FEATURE_ID =
  "FE.4814c115-d0a6-4ad7-86c5-8962a1856db0";
export const END_OF_CHAT_PROMPT_FEATURE_ID =
  "FE.3b72bdcc-0be3-451d-8a7b-78f35a0766d3";
export const FREE_TEXT_COMPLAINT_FEATURE_ID =
  "FE.cd0d386e-5134-45d5-a08d-f2bfd025f84a";
export function isPopulationFeature({ id }: { id: string }) {
  return id == POPULATION_FEATUREID || id.startsWith(SUBPOPULATION_PREFIX);
}

export const FREE_TEXT_COMPLAINTS_FEATURE_ID =
  "FE.cd0d386e-5134-45d5-a08d-f2bfd025f84a";

export function getSubPopulationFeatureID(r: Relations) {
  return SUBPOPULATION_PREFIX + r;
}

export function isSubPopulationFeatureID(id: string) {
  console.log("");
  return id && id.startsWith(SUBPOPULATION_PREFIX);
}

//Temp - to test covid disclaimer - TODO - remove
declare global {
  interface Window {
    setPatientCovidId: (id: string) => void;
  }
}
